'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _row = require('./row.js');

var _row2 = _interopRequireDefault(_row);

var _col = require('./col.js');

var _col2 = _interopRequireDefault(_col);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    Row: _row2['default'],
    Col: _col2['default']
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@alicd/next/lib/_components/@alicd/next-grid/lib/index.js
// module id = 85
// module chunks = 0